import { ENDPOINTS } from '../../apis/endpoints';
import { apiSlice } from '../../app/api/apiSlice';
import axios from 'axios';
import { setAttachmentUploadProgress } from './chatSlice';

export const chatApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getChats: builder.query({
      query: userCode => `${ENDPOINTS.CHAT.BASE}${userCode}`,
      providesTags: result =>
        result
          ? [{ type: 'Chat', id: 'LIST' }, ...result.map(({ _id }) => ({ type: 'Chat', id: _id }))]
          : [{ type: 'Chat', id: 'LIST' }],
    }),
    addChat: builder.mutation({
      queryFn: async (formData, api) => {
        try {
          const token = api.getState().auth.token;
          const result = await axios.post(`${process.env.REACT_APP_BASE_URL}${ENDPOINTS.CHAT.SEND}`, formData, {
            //...other options like headers here
            headers: {
              Authorization: `Bearer ${token}`,
            },
            onUploadProgress: upload => {
              //Set the progress value to show the progress bar
              let uploadloadProgress = Math.round((100 * upload.loaded) / upload.total);
              // api.dispatch(setUploadProgress(uploadloadProgress ));
              console.log(uploadloadProgress);
              api.dispatch(setAttachmentUploadProgress({ progress: uploadloadProgress, uploadStarted: true }));
            },
          });
          return { data: result.data };
        } catch (axiosError) {
          let err = axiosError;
          return {
            error: {
              status: err.response?.status,
              data: err.response?.data || err.message,
            },
          };
        }
      },
      async onQueryStarted (args, { dispatch, queryFulfilled }) {
        console.log('upload started');
        dispatch(setAttachmentUploadProgress({ progress: 0, uploadStarted: true }));

        try {
          const { data } = await queryFulfilled;
          dispatch(setAttachmentUploadProgress({ progress: null, uploadStarted: false }));
        } catch (err) {
          dispatch(setAttachmentUploadProgress({ progress: null, uploadStarted: false }));
        } finally {
          console.log('upload completed');
        }
      },
      invalidatesTags: [{ type: 'Chat', id: 'LIST' }],
    }),
    editChat: builder.mutation({
      query: ({ id, data }) => ({
        url: `${ENDPOINTS.CHAT.BASE}${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Chat', id }],
    }),
    deleteChat: builder.mutation({
      query: id => ({
        url: `${ENDPOINTS.CHAT.BASE}${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Chat', id }],
    }),
    getLinkPreview: builder.query({
      query: url => `${ENDPOINTS.UTILS.LINK_PREVIEW}?url=${encodeURIComponent(url)}`,
    }),
  }),
});

export const {
  useGetChatsQuery,
  useAddChatMutation,
  useEditChatMutation,
  useDeleteChatMutation,
  useGetLinkPreviewQuery,
} = chatApiSlice;
